// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","desktop":"App_desktop__xn-ln","mobile":"App_mobile__1Ge9j"};